package er.prateek.crossly.ads

/**
 * Where an ad may appear. [wireName] is the string Remote Config uses in
 * [BannerConfig.placements] and analytics uses as the `placement` param, so it is a
 * published contract -- rename the enum entry freely, never the wire name.
 */
enum class AdPlacement(val wireName: String) {
    HOME("home"),
    LEVEL_SELECT("level_select"),
    RESULTS("results"),

    /**
     * Deliberately absent from the default [BannerConfig.placements]. A banner beside a
     * puzzle in progress is the one placement that reliably costs sessions, so showing it
     * has to be an explicit console decision rather than something a default turns on.
     */
    CROSSWORD("crossword"),

    // --- Math modes. Level maps carry a banner by default (like LEVEL_SELECT); the play screens
    // do not (like CROSSWORD -- a banner beside an active, timed board costs sessions), but both
    // remain switchable from the console. Mode results reuse the shared RESULTS placement.
    MATH_LEVEL_SELECT("math_level_select"),
    MATH_CROSSWORD("math_crossword"),
    RIDDLE_LEVEL_SELECT("riddle_level_select"),
    RIDDLE_RUN("riddle_run"),

    /** Rewarded-only: buying back a lost streak. Never a banner slot. */
    STREAK_RESTORE("streak_restore"),
    ;

    companion object {
        fun fromWireName(wireName: String): AdPlacement? = entries.firstOrNull { it.wireName == wireName }
    }
}

/** What triggered a full-screen ad check -- carried into analytics as `trigger`. */
enum class AdTrigger(val wireName: String) {
    PUZZLE_COMPLETED("puzzle_completed"),
    DAILY_COMPLETED("daily_completed"),
    MATH_COMPLETED("math_completed"),
    RIDDLE_COMPLETED("riddle_completed"),
}
